import React, { useEffect } from 'react';
import $ from 'jquery';
import { Icon } from '@iconify/react';
import Footer from './Footer';
import Navbar from './Navbar';
import Hero from '../components/Home/Hero';
import Our_best_seller from '../components/Home/Our_best_seller';
import Trending_Searches from '../components/Home/Trending_Searches';
import Shop_By_Category from '../components/Home/Shop_By_Category';
import Results_You_Can_Feel from '../components/Home/Results_You_Can_Feel';
import Nutrition_You_Can_Trust from '../components/Home/Nutrition_You_Can_Trust';
import Newsletter from '../components/Home/Newsletter';
import ProductThumbnailVideo from '../components/Home/ProductThumbnailVideo';

const Home = () => {
  const certifications = [
    { img: '/assets/images/certificate/c1.png', alt: 'FDA' },
    { img: '/assets/images/certificate/c2.png', alt: 'HACCP' },
    { img: '/assets/images/certificate/c3.png', alt: 'GMP' },
    { img: '/assets/images/certificate/c4.png', alt: 'ISO' },
    { img: '/assets/images/certificate/c5.png', alt: 'FSSAI' },
    { img: '/assets/images/certificate/c6.png', alt: 'Non GMO' },
  ];

  useEffect(() => {
    /**=====================
             Quantity 2 js
         ==========================**/
    $('.addcart-button').click(function () {
      $(this).next().addClass('open');
      $('.add-to-cart-box .qty-input').val('1');
    });

    $('.qty-left-minus').on('click', function () {
      var $qty = $(this).siblings('.qty-input');
      var _val = $($qty).val();
      if (_val === '1') {
        var _removeCls = $(this).parents('.cart_qty');
        $(_removeCls).removeClass('open');
      }
      var currentVal = parseInt($qty.val());
      if (!isNaN(currentVal) && currentVal > 0) {
        $qty.val(currentVal - 1);
      }
    });

    $('.qty-right-plus').click(function () {
      if ($(this).prev().val() < 9) {
        $(this)
          .prev()
          .val(+$(this).prev().val() + 1);
      }
    });
  }, []);

  return (
    <>
      <Navbar />

      <Hero />

      <Our_best_seller />

      <Trending_Searches />

      <Shop_By_Category />

      <section className="evercore-standard">
        <div className="container-fluid-lg">
          <div className="standard-container">
            <span className="standard-eyebrow">THE EVERCORE STANDARD</span>
            <h2>Our Commitment to Quality & Purity</h2>

            <div className="standard-items">
              <div className="standard-item">
                <Icon icon="mdi:leaf" />
                <span>Monk Fruit Sweetened</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:flask-outline" />
                <span>Science-Led Formulation</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:stomach" />
                <span>Easy on Digestion</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:earth" />
                <span>Globally Sourced Ingredients</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:water-off" />
                <span>Preservative Free</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:run" />
                <span>Lifestyle Friendly</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Banner Section Start --> */}
      <section className="banner-section">
        <div className="container-fluid-lg">
          <div className="row ">
            <div className="col-12">
              <div
                className="banner-contain-3 section-b-space section-t-space hover-effect"
                style={{
                  backgroundImage: 'url("/assets/images/pp.webp")',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  minHeight: '420px',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  position: 'relative',
                  
                }}
              >
                {/* <img
                  src="assets/images/Yeast_Protein.png"
                  className="flower-pot img-fluid"
                  alt="img"
                  style={{
                    height: '200px',
                    marginRight: '50px',
                    marginBottom: '60px',
                    // borderRadius: '20px',
                  }}
                /> */}
                <div className="banner-detail p-center-left position-relative d-block py-0 banner-furniture mend-auto">
                  <div className="row">
                    <div className="col-xl-6 col-md-8 col-sm-9">
                      <h4 className="text-uppercase text-kaushan furniture-title">
                        Best of Collections{' '}
                        {/* <img
                          src="../assets/images/furniture/arrow.svg"
                          alt="img"
                        /> */}
                      </h4>
                      <h2 className="mt-sm-3 mt-1 mb-2 text-content text-black">
                        {' '}
                        Premium Protein LookBook
                      </h2>
                      <p
                        className="text-content"
                        style={{
                          color: '#46576B',
                          fontSize: '20px',
                          lineHeight: '1.5',
                          maxWidth: '550px',
                        }}
                      >
                        Explore our latest collection of clean, science-backed protein blends made
                        to support muscle growth, performance, and everyday wellness.
                      </p>
                      <a href="/Shop">
                        <button className="pro-acc-logout-btn mt-sm-4 mt-2 btn-md text-white fw-bold">
                          Shop Now
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Banner Section End --> */}

      <Results_You_Can_Feel />

      <ProductThumbnailVideo />
      <Nutrition_You_Can_Trust />

      <section className="certification-section">
        <div className="container-fluid-lg">
          <div className="title mb-4">
            <h2
              className="position-relative d-inline-block pb-3"
              style={{
                color: '#000',
              }}
            >
              Certifications
              {/* Underline */}
              <span
                className="position-absolute bottom-0 start-0"
                style={{
                  width: '60px',
                  height: '3px',
                  backgroundColor: '#000000',
                  borderRadius: '2px',
                }}
              />
            </h2>
          </div>

          {/* Slider with background color only */}
          <div
            className="new-slider-wrapper"
            style={{
              backgroundColor: '#90D5FF',
              padding: '30px 20px',
              borderRadius: '16px',
            }}
          >
            <div className="new-slider-slider">
              {[...certifications, ...certifications].map((item, index) => (
                <div
                  className="cert-item"
                  key={index}
                >
                  <a
                    href="/Shop"
                    className="cert-card"
                  >
                    <img
                      src={item.img}
                      alt={item.alt}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Newsletter />

      <Footer />

      {/* <!-- Quick View Modal Box Start --> */}
      <div
        className="modal fade theme-modal view-modal"
        id="view"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl modal-fullscreen-sm-down">
          <div className="modal-content">
            <div className="modal-header p-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-sm-4 g-2">
                <div className="col-lg-6">
                  <div className="slider-image">
                    <img
                      src="/assets/images/product1.webp"
                      className="img-fluid blur-up lazyload"
                      alt="img"
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="right-sidebar-modal">
                    <h4 className="title-name">Evercore Yeast Protein - Double Chocolate </h4>
                    <h4 className="price">₹ 1250.00</h4>
                    <div className="product-rating">
                      <ul className="rating">
                        <li>
                          <i
                            data-feather="star"
                            className="fill"
                          ></i>
                        </li>
                        <li>
                          <i
                            data-feather="star"
                            className="fill"
                          ></i>
                        </li>
                        <li>
                          <i
                            data-feather="star"
                            className="fill"
                          ></i>
                        </li>
                        <li>
                          <i
                            data-feather="star"
                            className="fill"
                          ></i>
                        </li>
                        <li>
                          <i data-feather="star"></i>
                        </li>
                      </ul>
                      <span className="ms-2">8 Reviews</span>
                      <span className="ms-2 text-danger">6 sold in last 16 hours</span>
                    </div>

                    <div className="product-detail">
                      <h4>Product Details :</h4>
                      <p>
                        Candy canes sugar plum tart cotton candy chupa chups sugar plum chocolate I
                        love. Caramels marshmallow icing dessert candy canes I love soufflé I love
                        toffee. Marshmallow pie sweet sweet roll sesame snaps tiramisu jelly bear
                        claw. Bonbon muffin I love carrot cake sugar plum dessert bonbon.
                      </p>
                    </div>

                    <ul className="brand-list">
                      <li>
                        <div className="brand-box">
                          <h5>Brand Name:</h5>
                          <h6>Black Forest</h6>
                        </div>
                      </li>

                      <li>
                        <div className="brand-box">
                          <h5>Product Code:</h5>
                          <h6>W0690034</h6>
                        </div>
                      </li>

                      <li>
                        <div className="brand-box">
                          <h5>Product Type:</h5>
                          <h6>White Cream Cake</h6>
                        </div>
                      </li>
                    </ul>

                    <div className="select-size">
                      <h4> Protein size:</h4>
                      <select className="form-select select-form-size">
                        <option>Select Size</option>
                        <option>1/2 KG</option>
                        <option>1 KG</option>
                        <option>1/5 KG</option>
                      </select>
                    </div>

                    <div className="modal-button">
                      <a
                        href="/cart"
                        className="btn btn-md pro-acc-logout-btn icon"
                      >
                        Add To Cart
                      </a>
                      <a
                        href=""
                        className="btn pro-acc-logout-btn view-button icon text-white fw-bold btn-md"
                      >
                        View More Details
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Quick View Modal Box End --> */}
    </>
  );
};

export default Home;
